import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import WJH from './js/wjhJS.js'
import animated from 'animate.css'
require('./js/setSize')
import Tool from './js/tool.js'
import Share from './js/shareAndGetName'
const configData = require('./assets/versions.json')

declare module 'vue/types/vue' { // 模块补充 可以去这个路径查阅
    interface Vue {
        url: string,
        wjh: any,
        [key: string]: any // 解决对象的遍历
    }
}
const URL = process.env.NODE_ENV === 'production' && process.env.VUE_APP_TITLE !== 'experiment' ? 'https://api.psy-1.com' : 'https://api.debug.psy-1.com'

Vue.config.productionTip = false
Vue.prototype.$wjh = WJH
Vue.use(animated)

new Vue({
  data () {
      return {
          showDownLoad: true,
          cosSleep: Tool.is_cosleep(),
          url: URL,
          imgSaver: '',
          ghostBed: { // 从choiceBedRoom 保存的数据

          },
          share: null,
          configData: configData[process.env.VUE_APP_TITLE === 'catch' ? 0 : 1] // 正确是 0 1
      }
  },
  methods: {
      shareM (title = configData.title, desc = '', picUrl = 'https://res.psy-1.com/FpgXF-VyS4VUQblIGL78wU-VUJdc') {
          // picUrl ? true : picUrl = this.amountData.weixinPic
          const url = process.env.VUE_APP_TITLE === 'catch' ? 'https://www.psy-1.com/cosleep/ghost?activity_type=1' : 'https://www.psy-1.com/cosleep/ghost?activity_type=2'
          const share = new Share({ pic: picUrl, url, title: process.env.VUE_APP_TITLE === 'catch' ? '偷眠小鬼捕获指南' : '失眠原因认领指南', desc }) // window.location.href.split('#')[0]
          this.share = share
          share.appShare()
          share.rawWeiXinShare(this.url)
      },
      test () {
          // @ts-ignore
          if (Tool.is_cosleep()) {
              this.cosSleep = true
              // @ts-ignore
              this.share.appGetName()
          }
      }
  },
  router,
  store,
  render: (h) => h(App),
    mounted () {
        document.title = this.configData.title
        this.shareM()
        // @ts-ignore
        _hmt.push(['_trackEvent', 'type', 'click', this.configData.type])
        // @ts-ignore
        if (Tool.is_cosleep()) {
            // @ts-ignore
            this.share.appGetName()
        }
        document.documentElement.addEventListener('touchstart', (event) => {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        }, false)
    }
}).$mount('#app')
